import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import responseHandler from "responseHandler";

import {
  getCaseIssueTypes,
  getCaseIssues,
  updateCaseIssues,
  beginUpdateCaseIssues
} from "requests/caseIssues";
import CaseIssueFields from "components/QualityAssurance/Sections/CaseDetails/CaseIssues/CaseIssueFields";
import { MSpinner } from "components/Shared";

const CaseIssues = (props) => {
  const mounted = useRef(true);
  const [caseIssueTypes, setCaseIssueTypes] = useState([]);
  const [caseIssues, setCaseIssues] = useState({});

  const { controlNumber, makeToast } = props;

  useEffect(() => {
    if (!caseIssueTypes.length) {
      getCaseIssueTypes(controlNumber, (s) => {
        setCaseIssueTypes(s);
        refreshIssues();
      }, mounted);
    }
    return () => {
      mounted.current = false;
    };
  }, []);

  const refreshIssues = () => {
    getCaseIssues(controlNumber, (s) => setCaseIssues(s), mounted);
  };

  const updateIssues = (caseIssues, caseComments, force) => {
    props.beginUpdateCaseIssues();
    let issuesArray = [];
    for (let issueGroup in caseIssues) {
      caseIssues[issueGroup].filter(s => s.checked)
        .forEach(s => issuesArray.push({ name: s.name, code: s.value }));
    }
    props.updateCaseIssues({
      controlIdNumber: controlNumber,
      caseIssues: issuesArray,
      caseIssueComments: caseComments,
    }, () => {
      refreshIssues();
      if (!force) {
        makeToast("Case Issues Saved", "success");
      }
    }, mounted);
  };

  if (!caseIssues.caseIssues) {
    return (<MSpinner />);
  }
  return (
    <CaseIssueFields
      caseIssues={caseIssues.caseIssues}
      caseIssueComments={caseIssues.caseIssueComments}
      caseIssueTypes={caseIssueTypes}
      updateIssues={updateIssues}
    />
  );
};

CaseIssues.propTypes = {
  controlNumber: PropTypes.number,
  makeToast: PropTypes.func.isRequired,
  updatingCaseIssues: PropTypes.bool,
  beginUpdateCaseIssues: PropTypes.func,
  updateCaseIssues: PropTypes.func,
};

const mdtp = dispatch => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
  beginUpdateCaseIssues() {
    dispatch(beginUpdateCaseIssues());
  },
  updateCaseIssues(payload, successCallback, mountedRef) {
    dispatch(updateCaseIssues(payload, successCallback, mountedRef));
  }
});

export default connect(null, mdtp)(CaseIssues);